import { render, staticRenderFns } from "./ContentViewSettingsDrawer.vue?vue&type=template&id=83e47c96&scoped=true&"
import script from "./ContentViewSettingsDrawer.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ContentViewSettingsDrawer.vue?vue&type=style&index=0&id=83e47c96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e47c96",
  null
  
)

export default component.exports